var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"alliances"},[(_vm.alliances)?_c('div',[_c('div',{staticClass:"produtos-wrapper"},[_c('AllianceItem')],1)]):(!_vm.alliances)?_c('LoadingBox'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }